export type Persona = 'todos' | 'engenheiro' | 'reporter' | 'social';

export const PERSONA_LABELS: Record<Persona, string> = {
  todos: 'Todos',
  engenheiro: 'Engenheiro',
  reporter: 'Repórter',
  social: 'Social Media',
};

export const PERSONA_ORDER: Persona[] = ['todos', 'engenheiro', 'reporter', 'social'];
